import { Box, Flex } from "@chakra-ui/react"
import { memo } from "react"

import { useAppSelector } from "../../app/hooks"
import { AVATAR_LAYER_ORDER, selectCharacterAvatar } from "./characterSlice"
import { usePerfRenderCount } from "../../perf/perfTrace"

// Every layer fills the container, so the container alone controls size.
const layerStyle: React.CSSProperties = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  zIndex: 1,
}

export const CharacterAvatar: React.FC = memo(function CharacterAvatar() {
  usePerfRenderCount("CharacterAvatar")
  const avatarData = useAppSelector(selectCharacterAvatar)

  return (
    <Box width="100%">
      <Flex alignItems="center" justifyContent="center">
        <Box
          m={{ base: 4, md: 8 }}
          aspectRatio={0.4}
          height={{ base: "min(40vh, 480px)", lg: "55vh" }}
          position="relative"
          overflow="hidden"
        >
          {/* 1. Skin — opaque figure fill, bottom of the stack */}
          {avatarData.skinLayer && (
            <img
              src={avatarData.skinLayer}
              alt=""
              decoding="async"
              style={layerStyle}
            />
          )}
          {/* 2. Eyes — always above skin */}
          <img
            src="/character/eyes-neutral.png"
            alt=""
            decoding="async"
            style={layerStyle}
          />
          {/* 3. Outline — line-art overlay above the skin fill and eyes,
              below clothing. Hardcoded: never user-changeable. */}
          <img
            src="/character/outline.png"
            alt=""
            decoding="async"
            style={layerStyle}
          />
          {/* 4. Remaining avatar layers (catalog order, not persisted keys) */}
          {AVATAR_LAYER_ORDER.filter(
            key => key !== "skinLayer" && avatarData[key],
          ).map(key => (
            <img
              key={key}
              src={avatarData[key]}
              alt=""
              decoding="async"
              style={layerStyle}
            />
          ))}
        </Box>
      </Flex>
    </Box>
  )
})
